import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { CreditsProvider } from './contexts/CreditsContext';
import Navbar from './components/Navbar';
import AppRoutes from './routes';
import Login from './pages/Login';
import { VerifyLogin } from './pages/VerifyLogin';
import { supabase } from './lib/supabase';
import Home from './pages/Home';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';

// 认证状态监听组件
const AuthListener: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // 初始检查会话状态
    const checkSession = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (session) {
        // 如果在公开页面，重定向到 dashboard
        if (location.pathname === '/' || 
            location.pathname === '/login' || 
            location.pathname === '/verify-login'
        ) {
          navigate('/dashboard', { replace: true });
        }
      } else {
        // 如果未登录且访问需要认证的页面，重定向到登录页
        if (location.pathname.startsWith('/dashboard') || 
            location.pathname.startsWith('/settings') ||
            location.pathname.startsWith('/admin')
        ) {
          navigate('/login', { replace: true });
        }
      }
    };
    
    checkSession();

    // 监听认证状态变化
    const { data: { subscription } } = supabase.auth.onAuthStateChange(async (event) => {
      if (event === 'SIGNED_IN') {
        // 只在登录时重定向到 dashboard
        if (location.pathname === '/login' || 
            location.pathname === '/verify-login'
        ) {
          navigate('/dashboard', { replace: true });
        }
      } else if (event === 'SIGNED_OUT') {
        navigate('/login', { replace: true });
      }
      // TOKEN_REFRESHED 事件不再触发重定向
    });

    return () => {
      subscription.unsubscribe();
    };
  }, [navigate, location]);

  return null;
};

const App: React.FC = () => {
  return (
    <Router>
      <AuthProvider>
        <CreditsProvider>
          <div className="min-h-screen bg-black">
            <AuthListener />
            <Navbar />
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/verify-login" element={<VerifyLogin />} />
              <Route path="/home" element={<Home />} />
              <Route path="/terms" element={<TermsOfService />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/*" element={<AppRoutes />} />
            </Routes>
          </div>
        </CreditsProvider>
      </AuthProvider>
    </Router>
  );
};

export default App;
